var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3389 34C56.1142 35.8305 57.0595 38.1618 56.9971 40.5557C56.9347 42.9497 55.8689 45.2413 54 47",
    stroke: "#FD5B01",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6779 27C65.2285 30.8018 67.119 35.6438 66.9942 40.6158C66.8694 45.5877 64.7377 50.3474 61 54",
    stroke: "#FCB800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 45.4607C21 47.6699 22.7909 49.4607 25 49.4607H32.1696C32.4127 49.462 32.6531 49.5254 32.877 49.6472C33.1009 49.769 33.3038 49.9468 33.4739 50.1703L41.7835 59.2807C43.6297 61.3049 47 59.9988 47 57.2591V22.7409C47 20.0012 43.6297 18.6951 41.7835 20.7193L33.4739 29.8297C33.3038 30.0532 33.1009 30.231 32.877 30.3528C32.6531 30.4746 32.4127 30.538 32.1696 30.5393H25C22.7909 30.5393 21 32.3301 21 34.5393V45.4607Z",
    stroke: "#8170FB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeVolume);
export default __webpack_public_path__ + "static/media/ChangeVolume.f9e00ac3.svg";
export { ForwardRef as ReactComponent };